var c = Object.defineProperty;
var d = (o, e, t) => e in o ? c(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t;
var r = (o, e, t) => d(o, typeof e != "symbol" ? e + "" : e, t);
import { Schema as m } from "prosemirror-model";
import { markSpecs as n } from "./specs/mark-specs.js";
import { nodeSpecs as s } from "./specs/node-specs.js";
class g {
  constructor(e) {
    r(this, "config");
    this.config = e;
  }
  schema() {
    if (this.containsMultipleListTypes())
      throw new Error("schema should not have both nested and non-nested lists");
    return new m(this.schemaSpec);
  }
  containsMultipleListTypes() {
    let e = this.config.allowedBlocks, t = e.some((i) => this.isListType(i)), a = e.some((i) => this.isNestedListType(i));
    return t && a;
  }
  get schemaSpec() {
    return { nodes: this.nodes, marks: this.marks };
  }
  get nodes() {
    let e = {
      doc: s.doc,
      text: s.text,
      hardBreak: s.hardBreak,
      marker: s.marker
    };
    return this.config.singleBlockMode && (e.doc = s.singleBlockDoc), this.config.templating && (e.template = s.template, e.template.infoResolver = this.config.templating.resolver), this.config.aiPromptData && (e.aiPromptData = s.aiPromptData, e.aiPromptData.infoResolver = this.config.aiPromptData.resolver, e.aiPromptData.commandsResolver = this.config.aiPromptData.commandsResolver), this.config.allowedBlocks.forEach((t) => {
      this.isListType(t) && !e.listItem ? e.listItem = s.listItem : t === "table" ? (e.tableRow = s.tableRow, e.tableCell = s.tableCell, this.config.tables.containers && (e.tableCell = {
        ...e.tableCell,
        content: "(block | list | table)+"
      })) : this.isNestedListType(t) ? e.nestedListItem = s.nestedListItem : t === "collapsibleSection" ? (e.collapsibleSectionSummary = s.collapsibleSectionSummary, e.collapsibleSectionContent = s.collapsibleSectionContent) : t === "imageText" && (e.imageText = s.imageText), e[t] = s[t];
    }), this.config.allowedInline.forEach((t) => {
      s[t] && (e[t] = s[t]);
    }), this.stripListIfNeeded(e), this.stripTableIfNeeded(e), e;
  }
  stripListIfNeeded(e) {
    if (e.orderedList || e.unorderedList || e.orderedNestedList || e.unorderedNestedList)
      return;
    let t = e.doc.content || "", a = /list\s*\|\s*/, i = /\s*\|\s*list/, l = t.replace(a, "").replace(i, "");
    e.doc = { ...e.doc, content: l };
  }
  stripTableIfNeeded(e) {
    if (e.table)
      return;
    let t = e.doc.content || "", a = /table\s*\|\s*/, i = /\s*\|\s*table/, l = t.replace(a, "").replace(i, "");
    e.doc = { ...e.doc, content: l };
  }
  isListType(e) {
    return e === "orderedList" || e === "unorderedList";
  }
  isNestedListType(e) {
    return e === "orderedNestedList" || e === "unorderedNestedList";
  }
  get marks() {
    let e = {};
    return this.config.allowedInline.forEach((t) => {
      n[t] && (e[t] = n[t]);
    }), e;
  }
}
export {
  g as SchemaGenerator
};
